module.exports = __webpack_public_path__ + "fonts/SupercellHeadline-Heavy.f9cd15cb.woff2";